import * as angular from "angular";
import { IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {OrderPlanningConfigurationRequestsService} from "./order-planning-configuration-requests.service";

export class OrderPlanningConfigurationService {
  constructor(private orderPlanningConfigurationRequestsService: OrderPlanningConfigurationRequestsService,
              private bringozLoaderService: BringozLoaderService, private $q: IQService, private $log) {
  }

  create(configuration) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.orderPlanningConfigurationRequestsService.create(configuration)
      .then((configuration) => {
        deferred.resolve(configuration);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  update(configuration) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.orderPlanningConfigurationRequestsService.update(configuration)
      .then((configuration) => {
        deferred.resolve(configuration);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  delete(configurationId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.orderPlanningConfigurationRequestsService.delete(configurationId)
      .then(() => {
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .service('orderPlanningConfigurationService', OrderPlanningConfigurationService);
